const VAT_PRICE = 1.2;

export const returnVatOfPriceOnly = (price: number) => {
  return price * VAT_PRICE - price;
};

export const returnPriceMinusVat = (price: number) => {
  return price * (1 / VAT_PRICE);
};

export const returnVatOfPrice = (price: number) => {
  const vat = returnPriceMinusVat(price);
  return price - vat;
};
